import { translate as uiText } from '@/shared/i18n';
export const presentationStrings = {
    contents: uiText("vidyalms.ui.1d704c8f7040c427", "In this lesson"),
    print: uiText("vidyalms.ui.2e9ebcdf5679bee7", "Print lesson"),
    downloadVideo: uiText("vidyalms.ui.9e6a91c146c14996", "Download video"),
    backToCourse: uiText("vidyalms.ui.fa7dcce95a411284", "Back to course"),
    preview: uiText("vidyalms.ui.324b134f57c70c72", "Preview"),
    learningSpace: uiText("vidyalms.ui.003f656eada72168", "YOUR LEARNING SPACE"),
    journey: uiText("vidyalms.ui.0921faea9b4ace41", "YOUR COURSE JOURNEY"),
    progress: (percent: number) => uiText("vidyalms.ui.25fa28090a1ec502", "{p0}% complete", { p0: Math.round(percent) }),
    chapter: (number: number) => uiText("vidyalms.ui.75a1110107f12baa", "CHAPTER {p0}", { p0: String(number).padStart(2, '0') }),
    lessonCount: (count: number) => uiText("vidyalms.ui.8cbaa55a52ef61e2", "{p0} {p1}", { p0: count, p1: count === 1 ? 'lesson' : 'lessons' }),
    searchLessons: uiText("vidyalms.ui.3e0c3720da492ff9", "Find a lesson"),
    noMatches: uiText("vidyalms.ui.c7098514eca2c22e", "No lessons match your search."),
    clearSearch: uiText("vidyalms.ui.3b7ea51793e9d906", "Clear search"),
    focus: uiText("vidyalms.ui.047cfdebdd839f7b", "Focus mode"),
    exitFocus: uiText("vidyalms.ui.d2238a93d45119f8", "Show curriculum"),
    completion: uiText("vidyalms.ui.f59ba37f768d5bf8", "Completion requirements"),
    lessonPosition: (current: number, total: number) => uiText("vidyalms.ui.f34cfe60c4f086a7", "LESSON {p0} OF {p1}", { p0: current, p1: total }),
    overview: uiText("vidyalms.ui.bcf9d86049ebf27a", "About this lesson"),
    knowledgeCheck: uiText("vidyalms.ui.caf8755c4da3068e", "KNOWLEDGE CHECK"),
    quizTitle: uiText("vidyalms.ui.3874720214dc75dd", "Bring it all together."),
    quizDescription: uiText("vidyalms.ui.2039a377143107c7", "Take a moment to put what you have learned into practice. Check the assessment details before you begin."),
    assessmentDetails: uiText("vidyalms.ui.7b82c43e52033690", "View assessment"),
    resources: uiText("vidyalms.ui.ab047bec0290f98c", "YOUR LEARNING TOOLKIT"),
    resourcesTitle: uiText("vidyalms.ui.e9e4e8b8eb8ca79c", "Take your learning with you."),
    assignment: uiText("vidyalms.ui.9a0a054ba814c5aa", "PUT IT INTO PRACTICE"),
    assignmentTitle: uiText("vidyalms.ui.358ac75047228389", "Make it your own."),
} as const;
